
import { GetJobPosts, GetJobRoles, GetListOfVendorsByEmployeeID, jobDetailsEmailTemplate, rtrEmailTemplate,CandidateRTREmailTemplate, SendJobDetailstoInternalLinkedinCandidates,  siteURL,SendCandidatePoolRTRMail, CustomEmail, SendRelocationMail,JobOpportunitytoCandidate} from "../apiconstants/constants";
import { useState, useEffect } from 'react';
import Axios from "axios";
import { useForm,Controller } from "react-hook-form";
import 'react-toastify/dist/ReactToastify.css';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Swal from "sweetalert2";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import { Link,useLocation } from "react-router-dom";
import { useCountry } from "../contexts/countrycodecontext.js";
import Select from 'react-select';
import WYSIWYGEditor from "../helpers/WYSIWYGEditor.js";
import CandidateLayout from "../commonlayouts/candidatelayout.js";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const SendEmail = () => {
  const [isDisabled, setIsDisabled] = useState(false);
  var apiUrl = {};
  const query = useQuery();
// const fullName = query.get("fullName");
// const candidateEmail = query.get("email");
const candidateMobileNumber = localStorage.getItem("mobileNumber");
  const location = useLocation();
  const {  fullName,candidateGuid, candidateEmail,emailType, } = location.state || {};
  const { selectedCountry} = useCountry();
  const { register, handleSubmit, formState,watch,setValue,control,getValues,reset} = useForm();
  const { errors } = formState
  const { isSubmitting } = formState;
  const [jobRoles, setJobRoles] = useState([]);
const [vendors, setVendors] = useState([]);
  const [jobPosts, setJobPosts] = useState([]);
const selectedJobRole = watch("JobRole");     // jobRoleId
const selectedVendorGuid = watch("VendorGuid"); // vGuid
const senderEmail = watch("clientemail"); // vGuid
const [showPreview, setShowPreview] = useState(false);
const [previewHtml, setPreview] = useState("");
      const payRatePlaceholder = selectedCountry == 1 ? 'Enter Current CTC' : 'Enter Pay Rate';
const token = localStorage.getItem("jwtToken");

  let Guid="";
      const guid = localStorage.getItem("guid");
      const employerGuid = localStorage.getItem("employerGuid")
      const email = localStorage.getItem("email");
      const mobileNumber = localStorage.getItem("mobileNumber")
      const roleID = localStorage.getItem("roleID")
      
      if(roleID==3){
       Guid = employerGuid
      }
      else{
        Guid= guid
      }
      const fetchJobRoles = async () => {
        const getApiUrl = `${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`;
        try {
            const response = await Axios.get(getApiUrl);
            setJobRoles(response.data);
        } catch (error) {
          console.error("Error fetching job roles", error);
        }
      };
      const GetVendorsList = () => {
     
        const GetapiUrl = GetListOfVendorsByEmployeeID.APIURL + `?UserGuid=${Guid}&CountryID=${selectedCountry}`;
      
        Axios.get(GetapiUrl)
          .then((result) => {
     
            setVendors(result.data);
          }).catch((error) => {
            console.log("Error" + error);
          });
      };
      useEffect(() => {
  fetchJobRoles();
  GetVendorsList();
}, []);
     useEffect(() => {
  if (selectedJobRole && selectedVendorGuid) {
    fetchFilteredJobPosts(selectedJobRole, selectedVendorGuid);
  } else {
    setJobPosts([]);
  }
}, [selectedJobRole, selectedVendorGuid]);

const fetchFilteredJobPosts = async (jobRoleId, vendorGuid) => {
  try {
    console.log("84",jobRoleId, vendorGuid)
    const response = await Axios.get(`${GetJobPosts.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    const filtered = response.data.filter(post =>
      post.jobRoleID == jobRoleId.value && post.vGuid == vendorGuid.value&&
       post.status=="Active"
    );
    setJobPosts(filtered);
  } catch (error) {
    console.error("Error fetching job posts", error);
  }
};


const handlePreview = () => {
  if (showPreview) {
    setShowPreview(false);
    setPreview("");
    return;
  }

  const values = getValues();
  console.log("144",values)
  const templateData = {
    candidateName: values.candidateName,
    jobTitle: values.jobTitle,
    location: values.location,
    jobType: values.jobType,
    jobDescription: values.jobDescription,
    candidateMobileNumber,
    senderEmail ,
    billRate: values.billRate,
    submissionLink: `${siteURL}/AddCandidate?uGuid=${Guid}&CountryID=${selectedCountry}`,
    recruiterName:values.recruiterName,
    endClientName: values.endClient,
       
  };

  let previewHtml;

if (emailType === "rtr") {
  previewHtml = CandidateRTREmailTemplate(templateData);
} else if (emailType === "followup") {
  
    previewHtml = `
   <br/>
   <p>${values.content}</p>
   <p>Best regards,<br />
   <strong>KnackHook Staffing Team,</strong><br />
     ✉️ <a href="mailto:${values.fromEmail}">${values.fromEmail},</a><br />
    📞 ${candidateMobileNumber}.<br /></p>
  `;

} 
 else if (emailType == "Relocate") {
  
   previewHtml = `
      <br/>
      <p>Hi <strong> ${values.candidateName} </strong>,</p>
      <p>
        It was nice speaking with you over the call. 
        <br/>
        We need confirmation regarding your willingness to relocate for the <strong>${values.jobTitle}</strong> position in <strong>${values.location}</strong>. Could you please confirm?
      </p>
      <p>
        <strong>Client Name:</strong> ${values.vendorCompanyName}<br/>
        <strong>End Client Name:</strong> ${values.endClient}<br/>
        <strong>Job Description:</strong> ${values.jobDescription}
      </p>
      <p>Best regards,<br />
        <strong>KnackHook Staffing Team</strong><br />
        ✉️ <a href="mailto:${senderEmail}">${senderEmail}</a><br />
        📞 ${candidateMobileNumber}<br />
      </p>
    `;
  
}
else if (emailType === "Submission") {
   previewHtml = `
      <br/>
     
  <div style="font-family: Arial, sans-serif; font-size: 14px; line-height: 1.6;">
    <p>Dear ${values.candidateName} ,</p>
 
    <p>Greetings from <strong>KnackHook</strong>!</p>
 
    <p>It was nice talking with you.</p>
 
    <p>As discussed, please submit the following details and share the necessary documents such as your I-94 travel history, DL copy, and visa copy for verification.</p>
 
    <p><strong>Candidate Name:</strong>${values.candidateName} </p>
    <p><strong>Position Title:</strong> ${values.jobTitle}</p>   
    <p><strong>Location:</strong> ${values.location}</p>
    <p><strong>Type:</strong> ${values.jobType}</p>
   
    ${values.endClientName ? `<p><strong>Implementation/End Client:</strong> ${values.endClientName}</p>` : ""}
 
        <br/>
 
    <p><strong>Submission details:</strong></p>
   
 <table style="border-collapse: collapse; width: 50%;" border="1" cellspacing="0" cellpadding="8">
  <tr>
    <th style="border: 1px solid black; width: 50%;">Candidate Info</th>
    <th style="border: 1px solid black; width: 50%;">Details</th>
  </tr>
  <tr>
    <td style="border: 1px solid black; width: 50%;">Legal Name</td>
    <td style="border: 1px solid black; width: 50%;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Email</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Mobile Number</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Passport Number (Must)</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Date of Birth (M/D)</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">VISA</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">US Entry (VISA Type/Year)</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Current location</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Last 4 Digits of SSN</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Highest education</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">LinkedIn Profile</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Availability to interview</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Certifications</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Availability for Joining</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Relocation</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">References (2 Must)</td>
    <td style="border: 1px solid black;"></td>
  </tr>
</table>
    <br/>
 
  <p><strong>Job Description : </strong> ${values.jobDescription} </p>
    <p>Best regards,<br />
    <strong>KnackHook Staffing Team,</strong><br />
     ✉️ <a href="mailto:${senderEmail}">${senderEmail},</a><br />
    📞 ${candidateMobileNumber}.<br />
   </p>
  </div>
`;
}
else {
  previewHtml = jobDetailsEmailTemplate(templateData);
}


  setPreview(previewHtml);
  setShowPreview(true);
};

useEffect(() => {
  reset({
    candidateName: fullName || "",
    email: candidateEmail || "",
    clientemail: email || "",   // your default sender email
    fromEmail: email || "",     // follow-up email sender
    JobRole: null,
    JobTitle: null,
    jobDescription: "",
    jobTitle: "",
    location: "",
    jobType: "",
    billRate: "",
    endClient: "",
    clientName: "",
    vendorCompanyName: "",
    subject: "",
    content: ""
  });

  // Reset react-select fields separately
  setValue("VendorGuid", null);
  setValue("JobRole", null);
  setValue("JobTitle", null);
  setIsDisabled(false);
  setShowPreview(false);
  setPreview("");
}, [fullName, candidateEmail, email, reset, setValue]);

const onSubmit = async (data, e) => {
  e.preventDefault();
  setIsDisabled(true);

  try {
    
    if (emailType === "rtr") {
      const rtrPayload = {
        userGuid: guid,
        guid:guid,
       candidateName: data.candidateName,
       candidateEmail: data.email,
        senderEmail:data.clientemail,
        phonenumber:mobileNumber,
        positionTitle: data.jobTitle,
        location: data.location,
        employmentType: data.jobType,
        billRate: data.billRate,
        submissionLink: `${siteURL}/AddCandidate?uGuid=${Guid}&CountryID=${selectedCountry}`,
        jobDescription: data.jobDescription,
        jobOpenings: 1, // optional
        recruiterName: data.recruiterName,
        endClientName:data.endClient,
        candidateGuid : candidateGuid,
        jobPostID:data.jobPostID
      };

      const result = await Axios.post(SendCandidatePoolRTRMail.APIURL, rtrPayload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (result.data.message?.includes("success")) {
        Swal.fire({
          icon: "success",
          title: "RTR Email sent successfully",
          timer: 3000,
          showConfirmButton: false
        });
      } else {
        Swal.fire({ icon: "error", title: "Failed to send RTR Email" });
      }
    } 
    else if (emailType === "Submission") {
      const submissionPayload = {

         userGuid: guid,
        guid:guid,
       candidateName: data.candidateName,
        recruiterName: data.recruiterName,
       candidateEmail: data.email,
       candidateGuid : candidateGuid,
        senderEmail:data.clientemail,
        phonenumber:mobileNumber,
        positionTitle: data.jobTitle,
        location: data.location,
        endClientName: data.endClient,
        employmentType: data.jobType,       
        submissionLink: `${siteURL}/AddCandidate?uGuid=${Guid}&CountryID=${selectedCountry}`,
        jobDescription: data.jobDescription,   
  };
    const result = await Axios.post(JobOpportunitytoCandidate.APIURL, submissionPayload,
{ headers: { Authorization: `Bearer ${token}` } }

    );
      if (result.data.message?.includes("Email sent successfully.")) {
        Swal.fire({
          icon: "success",
          title: "Candidate Job Oppurtunity Email sent successfully",
          timer: 3000,
          showConfirmButton: false
        });
      } else {
        Swal.fire({ icon: "error", title: "Failed to send Candidate Job Oppurtunity Email" });
      }
    }
   else if (emailType === "Relocate") {
      const relocatePayload = {
        userGuid: guid,
       candidateName: data.candidateName,
       candidateEmail: data.email,
        senderEmail:data.clientemail,
        phonenumber:mobileNumber,
        positionTitle: data.jobTitle,
        location: data.location,
        employmentType: data.jobType,
        billRate: data.billRate,
        guid:guid,
        submissionLink: `${siteURL}/AddCandidate?uGuid=${Guid}&CountryID=${selectedCountry}`,
        jobDescription: data.jobDescription,
        recruiterName: data.recruiterName,
        endClientName: data.endClient,
        clientName: data.vendorCompanyName,
        // vendorCompanyName:data.vendorCompanyName,
        candidateGuid : candidateGuid,
        jobPostID:data.jobPostID
      };

      const result = await Axios.post(SendRelocationMail.APIURL, relocatePayload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (result.data.message?.includes("success")) {
        Swal.fire({
          icon: "success",
          title: "Relocate Email sent successfully",
          timer: 3000,
          showConfirmButton: false
        });
      } else {
        Swal.fire({ icon: "error", title: "Failed to send RTR Email" });
      }
    } 
    else if (emailType === "jobdetails")  {
      // Job Details Email
      const payload = [{
        candidateName: data.candidateName,
        candidateEmail: data.email,
        senderEmail:data.clientemail,
        phoneNumber:mobileNumber,
        jobTitle: data.jobTitle || "",
        location: data.location || "",
        jobType: data.jobType || "",
        jobDescription: data.jobDescription || "",
        cc: "",
        endClientName: data.endClient,
        guid:  guid,
        jobPostID:data.jobPostID
      }];

      const result = await Axios.post(SendJobDetailstoInternalLinkedinCandidates.APIURL, payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (Array.isArray(result.data)) {
        const statusListHTML = result.data
          .map(item => `<li><b>${item.email}</b>: ${item.status}</li>`)
          .join("");

        Swal.fire({
          icon: "success",
          title: "Email Status",
          html: `<ul style="text-align: left; padding-left: 20px;">${statusListHTML}</ul>`,
          confirmButtonText: "OK",
          width: 600
        });

      } else {
        Swal.fire({
          icon: "error",
          title: "Failed to send Job Details Email"
        });
      }
    }
    else if (emailType === "followup") {
  const followUpPayload = {
    fromEmail: data.fromEmail,
    toEmail: data.toEmail,
    subject: data.subject,
    content: data.content,
    cc: "",
    phoneNumber:candidateMobileNumber,
    guid: guid
  };

  const result = await Axios.post(CustomEmail.APIURL, followUpPayload,
    { headers: { Authorization: `Bearer ${token}` } }
  );

  if (result.data =='Screening test reminder email sent.') {
    Swal.fire({
      icon: "success",
      title: "Follow Up Email Sent",
      // text: `${result.data[0]?.status}`,
      confirmButtonText: "OK",
    });
  } else {
    Swal.fire({
      icon: "error",
      title: "Failed to Send Follow Up Email",
    });
  }

  return;
}

  } catch (error) {
    console.error("Error sending email", error);
    Swal.fire({
      icon: "error",
      title: "Server Error",
      text: "Failed to send emails. Please try again later."
    });
  }finally {
    setIsDisabled(false);
reset({
  candidateName: fullName,       // candidate name
  email: candidateEmail,         // candidate email
  clientemail: email,            // sender email
  fromEmail: email,              // for follow-up email input
  JobRole: null,
  JobTitle: null,
  jobDescription: "",
  jobTitle: "",
  location: "",
  jobType: "",
  billRate: "",
  endClient: "",
  clientName: "",
  vendorCompanyName: "",
  subject: "",
  content: "",
  jobPostID: ""
});

// Reset selects separately if needed
setValue("VendorGuid", null);
setValue("JobRole", null);
setValue("JobTitle", null);
setShowPreview(false);

  }
};



  return (
    <ConsultantLayout>
      <section>
        <div className="container-fluid mt-4 pb-5">
                    <CandidateLayout title="Send Email" candidateGuid={candidateGuid} fullName= {fullName} email={candidateEmail}/>


<hr/>
<div class="card shadow-lg mt-5 p-5" style={{border:"none"}}>
                        
                        <div class="row mt-2">
<form onSubmit={handleSubmit(onSubmit)} >
  {emailType === "followup" ? (
   <>
    {/* Sender and Candidate Email in a Row */}
    <div className="row mt-4">
      <div className="col-sm-12 col-md-6">
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="tooltip-from">Sender's Email</Tooltip>}
        >
          <input
            type="email"
            className="form-control basic-form"
            placeholder="From Email"
            defaultValue={email}
            {...register("fromEmail", { required: "From Email is required" })}
          />
        </OverlayTrigger>
        {errors.fromEmail && (
          <div className="invalid-feedback d-block">{errors.fromEmail.message}</div>
        )}
      </div>

      <div className="col-sm-12 col-md-6">
     
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="tooltip-to">Candidate's Email</Tooltip>}
        >
          <input
            type="email"
            className="form-control basic-form"
            placeholder="To Email"
            defaultValue={candidateEmail}
            {...register("toEmail", { required: "To Email is required" })}
          />
        </OverlayTrigger>
        {errors.toEmail && (
          <div className="invalid-feedback d-block">{errors.toEmail.message}</div>
        )}
      </div>
    </div>
     <div className="row mt-4">
        <div className="col-sm-12 col-md-6">
               <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="tooltip-from">Candidate Name</Tooltip>}
        >
             <input
      className="form-control basic-form"
      type='text'
      {...register("candidateName")}
      placeholder="Enter candidate name"
      defaultValue={fullName}
    />
    </OverlayTrigger>
        </div>
    

    {/* Subject */}
    <div className="col-sm-12 col-md-6">
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id="tooltip-subject">Email Subject</Tooltip>}
      >
        <input
          type="text"
          className="form-control basic-form"
          placeholder="Subject"
          {...register("subject", { required: "Subject is required" })}
        />
      </OverlayTrigger>
      {errors.subject && (
        <div className="invalid-feedback d-block">{errors.subject.message}</div>
      )}
    </div>
 </div>
    {/* Content */}
    <div className="col-sm-12 mt-4">
      <label style={{ color: "#00a7ac", marginTop: 10 }}>Content</label>
      <Controller
        control={control}
        name="content"
        rules={{
          required: { value: true, message: "Content Required" },
        }}
        render={({ field: { onChange, onBlur, value, ref } }) => (
          <div>
            <WYSIWYGEditor
              onChange={onChange}
              onBlur={onBlur}
              value={value || ""}
              ref={ref}
              inputExtraProps={{
                required: true,
              }}
            />
            {errors.content && (
              <p style={{ marginTop: '0.25em', fontSize: '80%', color: '#dc3545' }}>
                {errors.content.message}
              </p>
            )}
          </div>
        )}
      />
    </div>
  </>
) : (
  <>
     <div className="row mt-2 p-0">
            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-5">
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Candidate Name</Tooltip>)}>
<input
      className="form-control basic-form"
      {...register("candidateName", { required: "Candidate Name is required" })}
      placeholder="Enter candidate name"
      defaultValue={fullName}
    />
    </OverlayTrigger>
    {errors.candidateName && (
      <div className="invalid-feedback d-block">{errors.candidateName.message}</div>
    )}


             
         <Controller
  name="JobRole"
  control={control}
  render={({ field }) => (
    <Select
      {...field}
      options={jobRoles.map(role => ({
        label: role.jobRole,
        value: role.jobRoleId // ✅ use jobRoleId
      }))}
      placeholder="Select Job Role"
     styles={{
        control: (provided) => ({
          ...provided,
          height: 50,
          borderRadius: 15,
          fontSize: 12,
          marginTop:20,
          borderColor: errors?.JobRole ? 'red' : provided.borderColor
        }),
        menu: (provided) => ({
          ...provided,
          zIndex: 9999,
          position: "absolute"
        })
      }}
    />
  )}
/>

<Controller 
  name="JobTitle"
  control={control}
  rules={{ required: "Job Title is required" }}
  render={({ field }) => (
    <Select
      {...field}
      options={jobPosts.map(job => ({
        label: `${job.title} - ${job.clientName}`,
        value: job.jobPostID,
        jobDescription: job.jobDescription,
        jobTitle: job.title,
        location: job.location,
        jobType: job.jobType,
        payRate:job.payRate,
        clientName:job.clientName,
        endClient:job.endClient,
        vendorCompanyName:job.vendorCompanyName,

      }))}
      placeholder="Select Job Title"
      value={jobPosts
        .map(job => ({
          label: `${job.title} - ${job.clientName}`,
          value: job.jobPostID,
          jobDescription: job.jobDescription,
          jobTitle: job.title,
          location: job.location,
          jobType: job.jobType,
          payRate:job.payRate,
          clientName:job.clientName,
          endClient:job.endClient,
          vendorCompanyName:job.vendorCompanyName,
        }))
        .find(option => option.value === field.value) || null}
      onChange={(selectedOption) => {
        field.onChange(selectedOption.value); // ✅ store jobPostID
        setValue("jobDescription", selectedOption.jobDescription);
        setValue("jobTitle", selectedOption.jobTitle);
        setValue("location", selectedOption.location);
        setValue("jobType", selectedOption.jobType);
        setValue("billRate", selectedOption.payRate ? `${selectedOption.payRate}` : "");
        setValue("endClient", selectedOption.endClient);
        setValue("clientName", selectedOption.clientName);
        setValue("vendorCompanyName",selectedOption.vendorCompanyName);
        setValue("jobPostID",selectedOption.value);

      }}
      styles={{
        control: (provided) => ({
          ...provided,
          height: 50,
          borderRadius: 15,
          fontSize: 12,
          marginTop:20,
          borderColor: errors?.JobTitle ? 'red' : provided.borderColor
        }),
        menu: (provided) => ({
          ...provided,
          zIndex: 9999,
          position: "absolute"
        })
      }}
    />
  )}
/>
{errors.JobTitle && (
  <div className="invalid-feedback d-block">
    {errors.JobTitle.message}
  </div>
)}
  {emailType == "rtr" && <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>{selectedCountry == 1 ? ' Current CTC' : 'Pay Rate'}</Tooltip>)}>
<input
  className="form-control basic-form mt-3"
 value={watch("billRate")}
  onChange={(e) => setValue("billRate", e.target.value)}
  placeholder={payRatePlaceholder}
/>
      
</OverlayTrigger>
}
{errors.billRate && (
        <div className="invalid-feedback d-block">{errors.billRate.message}</div>
      )}
</div>
<div className="col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-5">


<OverlayTrigger
  placement="bottom"
  overlay={(props) => (
    <Tooltip id="tooltip" {...props}>Email</Tooltip>
  )}
>
  <input
    type="email"
    {...register("email", { required: "Candidate Email is required" })}
    placeholder="Email"
    defaultValue={candidateEmail}
    className={`form-control basic-form ${errors.email ? 'is-invalid' : ''}`}
  />
</OverlayTrigger>

<div className="invalid-feedback">
  {errors.email?.message}
</div>

              
  <Controller
  name="VendorGuid"
  control={control}
  render={({ field }) => (
    <Select
      {...field}
      options={vendors.map(v => ({
        label:  `${v.vendorName} - ${v.vendorCompanyName}`,
        value: v.vGuid // ✅ use vGuid
      }))}
      placeholder="Select Client Name"
       styles={{
        control: (provided) => ({
          ...provided,
          height: 50,
          borderRadius: 15,
          fontSize: 12,
          marginTop:20,
          borderColor: errors?.VendorGuid ? 'red' : provided.borderColor
        }),
        menu: (provided) => ({
          ...provided,
          zIndex: 9999,
          position: "absolute"
        })
      }}
    />
  )}
/>
{errors.VendorGuid && (
  <div className="invalid-feedback d-block">
    {errors.VendorGuid.message}
  </div>
)}

   
     <OverlayTrigger
  placement="bottom"
  overlay={(props) => (
    <Tooltip id="tooltip" {...props}>From Email</Tooltip>
  )}
>
  <input
    type="email"
    {...register("clientemail", { required: "From Email is required" })}
    placeholder="From Email"
    defaultValue={email}
    className={`form-control basic-form mt-3 ${errors.clientemail ? 'is-invalid' : ''}` }
  />
</OverlayTrigger>      
           
 {emailType == "rtr" && <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Employer Name</Tooltip>)}>
  <input
        className="form-control basic-form mt-3"
        {...register("recruiterName",)}
        placeholder="Enter Employer Name"
      />
      
</OverlayTrigger>
}

   
            </div>
           
          </div>
  </>
)}

        
         
    
          <div className="row mt-4 p-0">
          <div className="col-12 d-flex justify-content-end gap-2">
              <button
    type="button"
    className="btn btn-primary"
    onClick={handlePreview}
  >
    {showPreview ? "✖ Close Preview" : "Show Preview"}
  </button>


  <button
    disabled={isSubmitting || isDisabled}
    className="btn btn-primary"
  >
    {isSubmitting && (
      <span className="spinner-border spinner-border-sm me-2"></span>
    )}
    Send
  </button>
 
    <button
    type="button"
     onClick={()=>window.scrollTo({ top: 0, behavior: "smooth" })}
      disabled={isSubmitting || isDisabled}
      className="btn btn-primary"
    >
      Cancel
    </button>

</div>

        </div>
        </form>
          {showPreview && previewHtml  && (
  <div className="mt-4 p-4 border rounded bg-light"  style={{   backgroundColor: 'transparent',fontSize: '12px', fontFamily: 'Arial, sans-serif', lineHeight: '1.5' }}>
    <h5>Email Preview</h5>
    <div dangerouslySetInnerHTML={{ __html: previewHtml }} />
  </div>
)}
        </div>
        </div>
                </div>
  </section>
    </ConsultantLayout>
  );
}

export default SendEmail;